import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { Auth } from 'aws-amplify';

export const downloadS3File = async (s3Uri: string) => {
  // Parse S3 URI
  const match = s3Uri.match(/^s3:\/\/([^\/]+)\/(.+)$/);
  if (!match) throw new Error('Invalid S3 URI');

  const [, bucket, key] = match;

  // Get the current authenticated user's JWT token
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();

  // Get credentials from Cognito Identity Pool with authentication
  const cognitoCredentials = fromCognitoIdentityPool({
    identityPoolId: 'us-east-1:29e0137e-28c0-4de7-b020-ed5426bd9ba6',
    logins: {
      [`cognito-idp.us-east-1.amazonaws.com/us-east-1_BRcmao5dM`]: idToken,
    },
    clientConfig: { region: 'us-east-1' },
  });

  // Create S3 client with authenticated Cognito credentials
  const s3Client = new S3Client({
    region: 'us-east-1',
    credentials: cognitoCredentials,
  });

  // Generate presigned URL
  const command = new GetObjectCommand({ Bucket: bucket, Key: key });
  const presignedUrl = await getSignedUrl(s3Client, command, { expiresIn: 3600 });

  // Trigger download
  const fileName = key.split('/').pop() || 'export.csv';
  const link = document.createElement('a');
  link.href = presignedUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
